/**
 * Text message part component (Apple-style MessageBubble)
 */

'use client';

import { MessageBubble } from 'widgets/chat/ui/MessageBubble';
import type { TextPart, MessageMode } from './types';

type TextMessagePartProps = {
  part: TextPart;
  mode: MessageMode;
  role: 'user' | 'assistant';
};

export function TextMessagePart({
  part,
  mode,
  role,
}: TextMessagePartProps) {
  if (mode !== 'view') {
    return null;
  }

  return (
    <MessageBubble
      role={role}
      text={part.text}
    />
  );
}
